import React, { Component, Fragment } from 'react';
import axios from 'axios';
import { Loader, Tab, Segment, Header, Responsive, Icon, Popup, Transition } from 'semantic-ui-react';
import ExternalStudentBasicInformation from './ExternalStudentBasicInformation';
import ExternalStudentFaculties from './ExternalStudentFaculties';
import ExternalStudentCourses from './ExternalStudentCourses';
import { toast, ToastContainer } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import ExternalStudentCertificates from '../../StudentService/StudentOverview/ExternalStudentCertificates';
import { fetchUserOrganizationalUnit } from '../../Assets/util/roles';
import ExternalStudentCompletionDetails from './ExternalStudentCompletionDetails';

class ExternalStudentProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            student: null,
            isMainOU: false,
            userOrganizationalUnitId: null,
            loading: true,
        };
        this.fetchStudent = this.fetchStudent.bind(this);
    }

    showToastMessage = () => {
        const { toastMessage } = this.props.location.state || {};
        if (toastMessage) {
            toast(<FormattedMessage id={toastMessage}/>);
            this.props.history.replace({
                ...this.props.location,
                state: {
                    ...this.props.location.state,
                    toastMessage: null
                }
            });
        }
    };

    componentDidMount() {
        Promise.all([
            axios.get(`/external-student-organization-unit/external-student/${localStorage.getItem('externalStudentId')}/main`),
            fetchUserOrganizationalUnit(),
        ])
            .then(([mainOrganizationalUnitResponse, userOrganizationalUnitResponse]) => {
                const mainOrganizationalUnitId = mainOrganizationalUnitResponse.data.organizationalUnit.id;
                const userOrganizationalUnitId = userOrganizationalUnitResponse.data;
                this.setState({
                    isMainOU: mainOrganizationalUnitId === userOrganizationalUnitId,
                    userOrganizationalUnitId
                });
            })
            .catch(error => {
                this.setState({ mainOU: false });
            })
            .finally(() => {
                if (!this.state.student) {
                    this.fetchStudent();
                } else {
                    this.setState({ loading: false }, this.showToastMessage);
                }
            });
    }

    fetchStudent() {
        const studentId = localStorage.getItem('externalStudentId');
        axios.get(`/external-student/${studentId}`)
            .then((res) => {
                this.setState({
                    student: res.data,
                    loading: false
                }, this.showToastMessage);
            })
            .catch((err) => {
                // console.error('Greška prilikom dohvata studenta:', err);
                this.setState({ loading: false });
            });
    }

    onEdit = (editedStudent) => {
        this.setState({ student: editedStudent });
        localStorage.setItem('externalStudentId', editedStudent.id);
    };

    render() {
        const {
            student,
            isMainOU,
            userOrganizationalUnitId,
            loading
        } = this.state;

        const localStorageRole = localStorage.getItem('activeRole');
        const isAdmin = localStorageRole === 'Administrator' || localStorageRole === 'AIDA';
        const isInternationalCooperationService = localStorageRole === 'Služba za međunarodnu saradnju';
        const isVicedeanForInternationalCooperation = localStorageRole.startsWith('Prodekan za međunarodnu');
        const isStudentService = localStorageRole.slice(0, 10) === 'Studentska';
        const isProfessor = localStorageRole.slice(0, 8) === 'Profesor';

        let { defaultTabIndex = 0 } = this.props.location.state || {};
        if (isProfessor) defaultTabIndex = 2;

        if (loading || !student) {
            return (
                <div style={{
                    paddingTop: '100px',
                    paddingBottom: '100px'
                }}><Loader active inline="centered"/></div>
            );
        }

        const panes = [
            {
                menuItem: { content: <FormattedMessage id="externalStudent.basicInformation"/> },
                render: () => (
                    <Tab.Pane attached={false} as={Responsive}>
                        <ExternalStudentBasicInformation
                            onEdit={this.onEdit}
                            student={student}
                            loading={loading}
                            isMainOU={isMainOU}
                        />
                    </Tab.Pane>
                )
            },
            {
                menuItem: { content: <FormattedMessage id="externalStudent.faculties"/> },
                render: () => (
                    <Tab.Pane attached={false} as={Responsive}>
                        <ExternalStudentFaculties externalStudentId={student.id} student={student}/>
                    </Tab.Pane>
                )
            },
            {
                menuItem: {
                    content: isStudentService
                        ? <FormattedMessage id="externalStudent.courseEnrollment"/>
                        : <FormattedMessage id="externalStudent.grades"/>
                },
                render: () => (
                    <Tab.Pane attached={false} as={Responsive}>
                        <ExternalStudentCourses externalStudentId={student.id} student={student}
                                                userOrganizationalUnitId={userOrganizationalUnitId}/>
                    </Tab.Pane>
                )
            },
            (isAdmin || isInternationalCooperationService || isVicedeanForInternationalCooperation || isStudentService) ? {
                menuItem: { content: <FormattedMessage id="externalStudent.completionDetails"/> },
                render: () => (
                    <Tab.Pane attached={false} as={Responsive}>
                        <ExternalStudentCompletionDetails onEdit={this.onEdit} student={student} loading={loading}
                                                          isMainOU={isMainOU}/>
                    </Tab.Pane>
                )
            } : null,
            {
                menuItem: {
                    content:
                        (isAdmin || isInternationalCooperationService || (isStudentService && isMainOU)) ?
                            <FormattedMessage id="externalStudent.documents"/>
                            : <Popup
                                content={<FormattedMessage id="externalStudent.noAccessToDocumentsTab"/>}
                                trigger={<span><FormattedMessage id="externalStudent.documents"/></span>}
                            />,
                    disabled: !(isAdmin || isInternationalCooperationService || (isStudentService && isMainOU))
                },
                render: () => (
                    <Tab.Pane attached={false} as={Responsive}>
                        <ExternalStudentCertificates
                            // studentId={student.studentId}
                            // studyProgramId={student.studyProgramId}
                            // limitation={this.state.locked || this.state.studyProgramStudentSwitchedToId }
                            student={student}
                        />
                    </Tab.Pane>
                )
            },
        ];

        return (
            <Fragment>

                <Header as="h1">
                    <Header.Content>
                        {<FormattedMessage id="externalStudent.studentProfile"/>}
                    </Header.Content>
                </Header>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            <Header.Content>
                                {`${student.firstName} ${student.lastName}`}
                            </Header.Content>

                            <span style={{
                                float: 'right',
                                textAlign: 'center'
                            }}>
                                <Icon name="lock" color={student.lockedAt ? 'blue' : 'grey'}/>
                                <Header.Subheader>
                                    &nbsp;Zaključan/a&nbsp;&nbsp;
                                </Header.Subheader>
                            </span>

                            <span style={{
                                float: 'right',
                                textAlign: 'center'
                            }}>
                                <Icon name="sign-out" color={student.dropoutDate ? 'red' : 'grey'}/>
                                <Header.Subheader>
                                    &nbsp;Ispisan/a&nbsp;&nbsp;
                                </Header.Subheader>
                            </span>

                            <span style={{
                                float: 'right',
                                textAlign: 'center'
                            }}>
                                <Icon
                                    name="user"
                                    color={!student.lockedAt && !student.dropoutDate ? 'blue' : 'grey'}
                                />
                                <Header.Subheader>
                                    &nbsp;Aktivan/na&nbsp;&nbsp;
                                </Header.Subheader>
                            </span>

                            <Header.Subheader>
                                {<FormattedMessage id="externalStudent.fullName"/>}
                            </Header.Subheader>
                        </Header>
                    </Segment>
                    <Segment>
                        <Tab menu={{
                            color: 'blue',
                            secondary: true,
                            pointing: true
                        }}
                             panes={panes}
                             defaultActiveIndex={defaultTabIndex}
                        />
                    </Segment>
                    <ToastContainer position="top-right" hideProgressBar={true}/>
                </Segment.Group>
            </Fragment>
        );
    }
}

export default ExternalStudentProfile;



// WEBPACK FOOTER //
// ./src/views/ExternalStudents/ExternalStudentProfile/ExternalStudentProfile.js